export default "<img *ngFor=\"let item of imageData; index as i\" [lightbox]=\"i\" [gallery]=\"'anotherLightbox'\" [src]=\"item.srcUrl\">";